module.exports = __webpack_public_path__ + "img/QLT-Benefit-Icon_2_22x19.8fb35242.svg";